// extracted by mini-css-extract-plugin
export default {"Auctions":"Auctions_Auctions__K5MH8","Auctions__new":"Auctions_Auctions__new__o-9qt","Auctions__table":"Auctions_Auctions__table__8V36g"};